import DetermineIfMobile from './components/DetermineIfMobile/DetermineIfMobile';

export default DetermineIfMobile;
